













































import { Component, Vue } from 'vue-property-decorator';
import { MailingListRecord } from '@/api/email.api';
import AddMembersDialog from './AddMembersDialog.vue';
import RemoveMembersDialog from './RemoveMembersDialog.vue';
import ImportMembersDialog from './ImportMembersDialog.vue';

@Component({
  components: {
    AddMembersDialog,
    RemoveMembersDialog,
    ImportMembersDialog
  }
})
export default class MailingListsModifyDialog extends Vue {
  dialogVisible = false;
  currentList: MailingListRecord | null = null;

  open(listRecord: MailingListRecord) {
    this.currentList = { ...listRecord };
    this.dialogVisible = true;
  }

  handleClose() {
    this.dialogVisible = false;
    this.currentList = null;
  }

  openAddDialog() {
    if (!this.currentList) return;
    (this.$refs.addMembersDialog as AddMembersDialog).open(this.currentList);
  }

  openRemoveDialog() {
    if (!this.currentList) return;
    (this.$refs.removeMembersDialog as RemoveMembersDialog).open(this.currentList);
  }

  openImportDialog() {
    if (!this.currentList) return;
    (this.$refs.importMembersDialog as ImportMembersDialog).open(this.currentList);
  }

  handleOperationSuccess() {
    this.$emit('success');
    this.handleClose();
  }
}
